import log from 'salvo-lite/log'

import OverlayScrollBar from 'overlayscrollbars'

class ScrollBar {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._options = this._getOptions()
        this._scrollBar = null
    }

    onInit () {
        log.debug(this._name, 'Initiated', this)
        this._scrollBar = new OverlayScrollBar(this._elem, this._options)
    }

    _attachEvent () {
        log.debug(this._name, 'Initialized', this)
        let mouseDown = false
        let oldX = 0
        let newX = 0
        let calc = 0
        this._elem.addEventListener('mousedown', e => {
            this._elem.classList.add('moving')
            mouseDown = true
            oldX = e.clientX
        })

        this._elem.addEventListener('mousemove', e => {
            if (!mouseDown) return false
            newX = e.clientX
            calc = oldX - newX
            oldX = newX
            if (calc !== 0) this._moveScrollBar(calc)
        })

        document.body.addEventListener('mouseup', e => {
            this._elem.classList.remove('moving')
            log.debug(this._name, 'MOUSE UP', e)
            mouseDown = false
        })
    }

    _moveScrollBar (calc) {
        this._scrollBar.scroll({ x: `+= ${calc}` })
    }

    _getOptions () {
        return {
            className: 'os-theme-minimal-dark',
            callbacks: {
                onInitialized: e => this._attachEvent()
            }
        }
    }
}

export default ScrollBar



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ScrollBar.js